import AuthService from "../../service";

const venueHireDetails = {
  getVenueHireDetails(page,search,sort_venue_hire,sort_date) {
    return AuthService.get(`service/venue_hire_details?`+
      `page=${page}` +
      `&sort_venue_hire=${sort_venue_hire}` +
      `&sort_date=${sort_date}` +
      `&search=${search}`
    );
  },
  showVenueHireDetails(id) {
    return AuthService.get("/service/venue_hire_details/" + id);
  },
  createVenueHireDetails(data) {
    return AuthService.post("/service/venue_hire_details", data);
  },
  updateVenueHireDetails(id, data) {
    return AuthService.put("/service/venue_hire_details/" + id, data);
  },
  deleteVenueHireDetails(id) {
    return AuthService.delete("/service/venue_hire_details/" + id);
  }
};
export default venueHireDetails;
